import { PillButton } from '../PillButton';
import { AddLinkIcon, IconSize } from '@ardoq/icons';
import { colors } from '@ardoq/design-tokens';
import { Text } from '@ardoq/typography';
import React, { useId } from 'react';
import {
  DropdownContainer,
  useDropdownTriggerContainer,
} from '@ardoq/dropdown-2026';
import { POPOVER_ARROW_SIZE, Popover2025 } from '@ardoq/popovers';
import styled, { css } from 'styled-components';
import { FlexBox } from '@ardoq/layout';
import { TertiaryButton } from '@ardoq/button';
import { DashboardPillLabels, defaultDashboardPillLabels } from './labels';

const GAP = 16;

const ARROW = css`
  &:before {
    content: '';
    left: 25%;
    margin-left: -${POPOVER_ARROW_SIZE / 2}px;
    height: ${POPOVER_ARROW_SIZE}px;
    width: ${POPOVER_ARROW_SIZE}px;
    background: ${colors.surfaceDefault};
    position: absolute;
    pointer-events: none;
    box-shadow: -1px -1px 1px rgba(0, 0, 0, 0.1);
    transform: rotate(45deg);
    bottom: calc(100% - ${POPOVER_ARROW_SIZE / 2 + GAP}px);
  }
`;

const LinkChartsDropdownContainer = styled(DropdownContainer)`
  max-width: 300px;
  margin-top: ${GAP}px;
  ${ARROW};
`;

export type LinkButtonProps = {
  onClick: VoidFunction;
  showLinkChartPopover: boolean;
  hideLinkChartPopover: VoidFunction;
  labels?: DashboardPillLabels;
};

export const LinkButton = ({
  showLinkChartPopover,
  hideLinkChartPopover,
  onClick,
  labels = defaultDashboardPillLabels,
}: LinkButtonProps) => {
  const popoverId = useId();
  const linkChartsDropdownTriggerRef =
    useDropdownTriggerContainer<HTMLButtonElement>({
      isOpen: showLinkChartPopover,
      openDropdown: () => {},
    });
  return (
    <>
      <PillButton
        autoFocus
        onClick={onClick}
        $isActive={false}
        aria-label={labels.linkChartsButton}
        aria-haspopup="dialog"
        aria-controls={popoverId}
        aria-expanded={showLinkChartPopover}
        ref={linkChartsDropdownTriggerRef}
      >
        <AddLinkIcon
          iconSize={IconSize.SMALL}
          color={colors.iconActionActive}
        />
        <Text color="textAction">{labels.linkChartsButton}</Text>
      </PillButton>
      <Popover2025
        isOpen={showLinkChartPopover}
        onClose={hideLinkChartPopover}
        onClickOutside={hideLinkChartPopover}
        id={popoverId}
        anchorRef={linkChartsDropdownTriggerRef}
        placement={{
          side: 'bottom',
          overflow: 'right',
        }}
      >
        <LinkChartsDropdownContainer>
          <FlexBox
            flexDirection="column"
            gap="medium"
            justify="flex-end"
            padding="medium"
          >
            {labels.linkChartsHint}
            <FlexBox justify="flex-end">
              <TertiaryButton onClick={hideLinkChartPopover}>
                {labels.closeButton}
              </TertiaryButton>
            </FlexBox>
          </FlexBox>
        </LinkChartsDropdownContainer>
      </Popover2025>
    </>
  );
};
